import { render, staticRenderFns } from "./LeaveMessage.vue?vue&type=template&id=c6e5ed84&"
import script from "./LeaveMessage.vue?vue&type=script&lang=js&"
export * from "./LeaveMessage.vue?vue&type=script&lang=js&"
import style0 from "./LeaveMessage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports